module.exports = __webpack_public_path__ + "img/business-4.466ff5d2.png";